/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IShipmentsMissingInfoCountsQueryVariables = Types.Exact<{ [key: string]: never }>

export type IShipmentsMissingInfoCountsQuery = { __typename?: 'Query' } & {
  shipmentsMissingInfo: { __typename?: 'ShipmentMissingInfoConnection' } & Pick<
    Types.IShipmentMissingInfoConnection,
    'totalCount'
  > & {
      itemizedCount: { __typename?: 'MissingInfoCounts' } & Pick<
        Types.IMissingInfoCounts,
        'missingEta' | 'totalMissingAssignments' | 'totalMissingDocuments'
      >
    }
}

export const ShipmentsMissingInfoCountsDocument = gql`
  query ShipmentsMissingInfoCounts {
    shipmentsMissingInfo(activeLoads: true) {
      itemizedCount {
        missingEta
        totalMissingAssignments
        totalMissingDocuments
      }
      totalCount
    }
  }
`

/**
 * __useShipmentsMissingInfoCountsQuery__
 *
 * To run a query within a React component, call `useShipmentsMissingInfoCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentsMissingInfoCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentsMissingInfoCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipmentsMissingInfoCountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IShipmentsMissingInfoCountsQuery,
    IShipmentsMissingInfoCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IShipmentsMissingInfoCountsQuery,
    IShipmentsMissingInfoCountsQueryVariables
  >(ShipmentsMissingInfoCountsDocument, options)
}
export function useShipmentsMissingInfoCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IShipmentsMissingInfoCountsQuery,
    IShipmentsMissingInfoCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IShipmentsMissingInfoCountsQuery,
    IShipmentsMissingInfoCountsQueryVariables
  >(ShipmentsMissingInfoCountsDocument, options)
}
export type ShipmentsMissingInfoCountsQueryHookResult = ReturnType<
  typeof useShipmentsMissingInfoCountsQuery
>
export type ShipmentsMissingInfoCountsLazyQueryHookResult = ReturnType<
  typeof useShipmentsMissingInfoCountsLazyQuery
>
export type ShipmentsMissingInfoCountsQueryResult = Apollo.QueryResult<
  IShipmentsMissingInfoCountsQuery,
  IShipmentsMissingInfoCountsQueryVariables
>
